import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OneDriveItem } from '../onedrive-list/onedrive-item.type';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class OneDriveItemService {
   constructor(private http: HttpClient) {}

   /**
    * Send a PATCH request directly to Microsoft to update a DriveItem in OneDrive.
    *
    * Our backend has problem to handle PATCH request. Thus, we use the frontend to handle this.
    *
    * @param data Request body: should be the values for properties to be updated.
    * @param accessToken Bearer Token for Microsoft OneDrive API
    *
    * @see https://learn.microsoft.com/en-us/onedrive/developer/rest-api/api/driveitem_update
    */
   update(
      access_token: string,
      itemId: OneDriveItem['id'],
      data: OneDriveItem,
      eTag?: OneDriveItem['eTag'] | OneDriveItem['cTag']
   ): Observable<OneDriveItem> {
      const url = `https://graph.microsoft.com/v1.0/me/drive/items/${itemId}`;
      let headers = {
         Authorization: `Bearer ${access_token}`,
         'Content-Type': 'application/json'
      };
      if (eTag) {
         headers['If-Match'] = eTag;
      }

      return this.http.patch(url, data, { headers });
   }
}
